module.exports = __webpack_public_path__ + "img/126.5.bb64c931.png";